/* =====================================================================
   Boost AI Search – našeptávač tipa.eu (motiv Enterprise):
   hledané výrazy, značky, dostupnost, „Přidat do košíku", pozice okna.
   Načíst za skripty motivu, např. řádkem
   <script src="{{ 'custom-boost-search.js' | asset_url }}"
           data-dotazy="{{ 'custom-boost-search-dotazy.json' | asset_url }}"
           data-znacky="{{ 'custom-boost-search-znacky.json' | asset_url }}"
           data-kategorie="{{ 'custom-boost-search-kategorie.json' | asset_url }}" defer></script>
   vedle custom.css v layout/theme.liquid.

   Progresivní vylepšení: když cokoli selže (Boost změní DOM, API
   nevrátí varianty), našeptávač zůstane tak, jak je dnes.

   Jak to funguje:
   1. Obal nad window.fetch odchytí odpověď Boost API
      (services.mybcapps.com/bc-sf-filter/search/suggest) – ta nese
      k produktu varianty (id, dostupnost, sklad). Uloží mapu
      handle -> {variantId, available, qty}. Vlastní interceptor
      Boostu (instantSearchAPI.interceptors) tenhle požadavek
      neobsluhuje, ověřeno 19. 9. 2026.
   2. MutationObserver po každém překreslení našeptávače doplní
      k položce štítek dostupnosti a tlačítko košíku; štítek slevy
      (Boost ho kreslí na fotku) přendá těsně nad cenu.
   3. Košík: stejný POST /cart/add se `sections` jako product-form.js
      v Enterprise, pak ProductForm.updateCartIcon(data), zavření
      našeptávače (closeSearch) a cartDrawer.renderContents(data, true)
      – drawer se otevře s aktuálním obsahem.
   4. Pozice okna: CSS má okno position:fixed a top z --tipa-isw-top;
      skript proměnnou nastaví na spodní hranu pole + 6 px (jinak by
      „top:auto" u dvouřádkového menu spadl až pod navigaci).

   5. Hledané výrazy: slovník custom-boost-search-dotazy.json
      (build_boost_search_dotazy.py z Google Ads + Search Console) se
      načte při prvním fokusu do pole; napovídá podle prefixu bez ohledu
      na diakritiku, napsaná část tučně. Boost ani Shopify vlastní návrhy
      pro nový obchod nemají (historie hledání je prázdná, ověřeno 21. 9.).
   6. Kategorie a Značky „kde se takový produkt vyskytuje": každý produkt
      v odpovědi Boostu nese své kolekce (handle, title) včetně značkové
      (brand-*). Boost sám navrhuje kolekce jen podle shody titulku, takže
      pro „ut18" nenajde nic – my doplníme kolekce nalezených produktů,
      nejčastější napřed. Značky = brand-* kolekce produktů + brand-*
      položky, které Boost dal mezi kategorie.
   7. Články: Boost hledá jen v titulku. Doplníme nativní Shopify
      /search/suggest.json (type=article, fields=title,body), které
      najde i zmínku v textu článku. Jeden požadavek na jeden dotaz Boostu.
   8. Dotaz = značka („uni-t"): při Enteru i při prokliku na návrh dotazu místo /search?q= (Boost vrátí i „Uni Black",
      „univerzální"… – 1 340 místo 342) jde návštěvník rovnou na značkovou kolekci.
      Mapa custom-boost-search-znacky.json (build_boost_search_znacky.py z
      /collections.json, značky s 20+ produkty, bez běžných slov). Boost hromadný
      import redirectů nemá (22. 9. 2026). V našeptávači se u takového dotazu
      tlačítko „Zobrazit N produktů" změní na „Zobrazit vše od ZNAČKA".
   9. Výchozí stav (klik do pole, nic napsáno): Boost tam umí jen Poslední hledání,
      Nejhledanější dotazy a Oblíbené produkty – kolekce ne (ověřeno 22. 9. 2026).
      Doplníme blok „Oblíbené kategorie": 5 kusů losovaných z 50 nejhledanějších
      (custom-boost-search-kategorie.json, build_boost_search_kategorie.py),
      vážené silou poptávky. Losuje se jednou za návštěvu (sessionStorage), aby
      se dlaždice při opakovaném otevření okna neměnily pod rukama.
      Primárně se ale počítají ŽIVĚ z dat, která si Boost sám vede: jeho seznam
      populárních hledání (suggestionNoResult.search_terms, typ based_on_data)
      se přeloží na kolekce přes API. Seznam se tak aktualizuje sám, jak se mění
      hledání v obchodě; statický žebříček z Ads slouží jako záloha a doplnění
      do plného počtu (rozhodnuto 22. 9. 2026 – jinak by data tiše stárla).
  10. Obrázek u kategorie (4. 10. 2026): hlavní sekce K1 = piktogram jako v menu
      „Všechny kategorie“, ostatní úrovně = miniatura fotky z menu (imageUrl), bez fotky
      šedé políčko jako v menu. Data dodává sekce tipa-isw-kategorie (z metapole stromu
      menu, vždy aktuální); stáhne se při prvním najetí na pole a drží se v sessionStorage.
      Kolekce mimo strom (Výprodej & Akce…) = obecná ikona z CSS.
  12. Karty Boostu v kolekcích: „Přidat do košíku“ přes drawer bez přesměrování (start()).
  11. Banner: skrytý odkaz [data-tipa-isw-banner] (snippet tipa-bar, blok „TIPA banner
      ve vyhledávání“ v nastavení záhlaví) se přesune do třetího sloupce desktopového okna.
      Obrázek se stáhne s předstihem, když myš najede na pole hledání.
   Pořadí v levém sloupci: Hledané výrazy, Kategorie, Značky, Blog & Stránky.
   Mobilní šablona Boostu (jeden sloupec, produkty v něm): Hledané výrazy (max 3),
   Produkty, Kategorie, Značky, Blog & Stránky – doplněno 22. 9. 2026.

   Boost našeptávač inicializuje až po první interakci uživatele
   (mousemove/scroll/keydown), ne při načtení – proto se skript věší
   na MutationObserver a ne na load. Levý sloupec Boost při každém
   překreslení staví znovu, takže i naše skupiny se staví znovu
   (značka data-tipa-groups brání dvojímu vložení).

   Dostupnost, expedici a cenu bez DPH NEPOČÍTÁME. Stahují se hotové z motivu
   (sekce mx-boost-api), stejně jako to dělá mx-boost.js u karet v kategoriích –
   viz doplnZMotivu(). Vlastní odhad z Boost indexu zůstal jen jako záložka pro
   případ, že sekce nedorazí: available && qty > 0 -> Skladem, available &&
   qty <= 0 -> Na objednávku, jinak Vyprodáno. Ten odhad se od motivu lišil
   (motiv bere stav z ERP, ne z počtu kusů) – to byl důvod téhle změny 22. 9. 2026.

   Produkt s více variantami dostane místo košíku šipku na detail –
   variantu nehádáme.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__tipaIswAtc) return;
  window.__tipaIswAtc = true;

  var SUGGEST_URL = 'bc-sf-filter/search/suggest';
  var SEL_ITEM = '.boost-sd__suggestion-queries-item--product';
  var SEL_LINK = 'a.boost-sd__suggestion-queries-item-link';
  var SEL_SKU = '.boost-sd__suggestion-queries-item-sku';
  var SEL_RIGHT = '.boost-sd__suggestion-queries-item-product--right';
  var DOTAZY_URL = (document.currentScript && document.currentScript.getAttribute('data-dotazy')) || null;
  var ZNACKY_URL = (document.currentScript && document.currentScript.getAttribute('data-znacky')) || null;
  var KATEGORIE_URL = (document.currentScript && document.currentScript.getAttribute('data-kategorie')) || null;
  var KAT_SECTION = 'tipa-isw-kategorie';
  var KAT_KEY = 'tipa-isw-kat-1';
  var MAX_DEFAULT_CATS = 5;
  var SESSION_KEY = 'tipa-isw-kategorie';
  var ZIVE_DOTAZU = 6;          /* kolik Boostových populárních hledání se použije na živý výpočet */
  var MAX_QUERIES = 5, MAX_CATS = 5, MAX_BRANDS = 4, MAX_ARTICLES = 3;
  /* 12 hlavních sekcí (K1) – v odvozených kategoriích až na konec, mají je všechny produkty
     (handly z živého menu 21. 9. 2026; po změně adres kolekcí aktualizovat) */
  /* Kolekce, které nechceme nabízet jako kategorii. Záměrně JMENOVITÝ seznam, ne vzor:
     vzor „akcni" vyhazoval i „Akční kamery", což je skutečná kategorie (22. 9. 2026).
     Akční a sezónní kolekce (Výprodej & Akce, Nejprodávanější, Novinky) se nabízet MAJÍ –
     marketingové rozhodnutí klienta. Držet v souladu s BLOKOVANE v
     scripts/build_boost_search_kategorie.py. Značky (brand-*) mají vlastní skupinu. */
  var BLOKOVANE = {
    'kolekce-produkty-v-akci': 1,   /* interní název, duplicita k „Výprodej & Akce" */
    'frontpage': 1, 'all': 1, 'vse': 1
  };
  var K1 = { 'audio-video': 1, 'auto-a-moto': 1, 'baterie-a-napajeni': 1, 'domacnost-a-spotrebice': 1, 'dilna-a-naradi': 1,
             'fotovoltaika': 1, 'merici-technika': 1, 'osvetleni-elektro-a-zabezpeceni-1': 1, 'soucastky': 1,
             'sport-a-outdoor': 1, 'zahrada': 1, 'zdravi-a-pece-o-telo': 1 };
  var TXT = {
    queries: 'Hledané výrazy',
    brands: 'Značky',
    viewBrand: 'Zobrazit vše od {znacka}',
    cats: 'Kategorie',
    favCats: 'Oblíbené kategorie',
    articles: 'Články',
    inStock: 'Skladem',
    onOrder: 'Na objednávku',
    soldOut: 'Vyprodáno',
    ship: 'Expedice',
    add: 'Přidat do košíku',
    pick: 'Vybrat variantu',
    view: 'Zobrazit produkt'
  };

  var map = {};
  var vendors = [];            /* výrobci z poslední odpovědi našeptávače */
  var prodCats = [];           /* kolekce nalezených produktů: {handle,title,n,brand} podle četnosti */
  var articles = [];           /* články ze Shopify hledání pro poslední dotaz: {title,url} */
  var articlesFor = '';
  var lastQuery = '';
  var lastSuggestUrl = '';      /* šablona pro vlastní dotazy na API (živé kategorie) */
  var origFetch = window.fetch;

  function queryFromUrl(url) {
    var m = /[?&]q=([^&]*)/.exec(url);
    try { return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; } catch (e) { return ''; }
  }

  function collectCats(products) {
    var acc = {};
    products.forEach(function (pr) {
      (pr.collections || []).forEach(function (c) {
        if (!c || !c.handle || BLOKOVANE[c.handle]) return;
        var a = acc[c.handle] || (acc[c.handle] = { handle: c.handle, title: c.title || c.handle, n: 0, brand: /^brand-/.test(c.handle) });
        a.n++;
      });
    });
    prodCats = Object.keys(acc).map(function (k) { return acc[k]; });
    /* K1 na konec, pak četnost, pak delší (konkrétnější) název */
    prodCats.sort(function (a, b) { return (K1[a.handle] ? 1 : 0) - (K1[b.handle] ? 1 : 0) || b.n - a.n || b.title.length - a.title.length; });
  }

  function fetchArticles(q) {
    if (!q || q.length < 2 || articlesFor === q) return;
    articlesFor = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=article&resources[limit]=' + MAX_ARTICLES + '&resources[options][fields]=title,body';
    origFetch.call(window, url).then(function (r) { return r.json(); }).then(function (j) {
      if (articlesFor !== q) return;
      var arr = (j && j.resources && j.resources.results && j.resources.results.articles) || [];
      articles = arr.map(function (a) { return { title: a.title, url: a.url }; });
      schedule();
    }).catch(function () { /* bez článků */ });
  }

  /* 1. odchyt odpovědi našeptávače */
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url.indexOf(SUGGEST_URL) !== -1) {
      p.then(function (r) { return r.clone().json(); }).then(function (j) {
        var seen = {};
        vendors = [];
        lastQuery = queryFromUrl(url) || (j.query || '');
        lastSuggestUrl = url;
        collectCats(j.products || []);
        fetchArticles(lastQuery);
        (j.products || []).forEach(function (pr) {
          if (pr.vendor && !seen[pr.vendor]) { seen[pr.vendor] = 1; vendors.push(pr.vendor); }
          var vs = pr.variants || [];
          map[pr.handle] = {
            id: vs.length === 1 ? vs[0].id : null,
            available: !!pr.available,
            qty: vs.reduce(function (s, v) { return s + (v.inventory_quantity || 0); }, 0)
          };
        });
        schedule();
      }).catch(function () { /* nic – položky zůstanou bez doplňků */ });
    }
    return p;
  };

  /* 3. přidání do košíku */
  function cartSection() {
    var cd = document.querySelector('cart-drawer');
    var sec = cd && cd.closest('.shopify-section');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  /* zavřít našeptávač (okno Boostu + overlay motivu), než se otevře cart drawer –
     jinak zůstane okno otevřené nad drawerem (nalezeno na dev 22. 9. 2026) */
  function closeSearch() {
    var c = window.boostISWModule && window.boostISWModule.instantSearchController;
    try { if (c && c.closeSuggestion) c.closeSuggestion(); } catch (e) { /* nic */ }
    var ps = document.querySelector('predictive-search');
    try { if (ps && ps.close) ps.close(); } catch (e) { /* nic */ }
    var ov = document.querySelector('.js-search-overlay.is-visible');
    if (ov) ov.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    var mob = document.querySelector('.boost-sd__instant-search-container-mobile .boost-sd__button-text-x--close');
    if (mob && mob.offsetParent) mob.click();
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  }

  function addToCart(variantId, btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    var sections = 'cart-icon-bubble';
    var sid = cartSection();
    if (sid) sections += ',' + sid;
    fd.append('sections', sections);
    fd.append('sections_url', window.location.pathname);
    var route = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add';
    var data;
    /* přes aktuální window.fetch, ne origFetch: gtm-tracking-cart-monitoring.js motivu
       hlídá /cart/add vlastním obalem nad fetch a přidání z našeptávače by jinak
       v analytice chybělo (zjištěno 22. 9. 2026) */
    return window.fetch(route, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (res) {
      return res.json().then(function (j) { data = j; if (!res.ok || j.status) throw new Error(j.description || j.message || res.status); });
    }).then(function () {
      var PF = window.customElements && customElements.get('product-form');
      if (PF && PF.updateCartIcon) PF.updateCartIcon(data);
      closeSearch();
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.renderContents) return cd.renderContents(data, true);
      window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    }).then(function () {
      /* on:cart:add pro komponenty motivu, které na něj poslouchají. Schválně BEZ
         durationMs: gtm-tracking-cart-monitoring.js by z něj udělal druhou událost
         add_to_cart_timing (první už vzniká z jeho hlídače volání /cart/add, se
         source: "other" – to je pravdivé). Ověřeno na dev 22. 9. 2026. */
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: variantId, source: 'instant-search' } }));
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
    }).catch(function (e) {
      if (window.console) console.warn('[tipa-isw-atc]', e);
      btn.classList.add('is-error');
      setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
    }).then(function () { btn.classList.remove('is-loading'); });
  }

  /* 2. doplnění položek */
  function handleOf(a) {
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('/products/');
    if (i === -1) return null;
    return href.slice(i + 10).split(/[?#]/)[0];
  }

  /* ---- 2a. údaje z motivu: dostupnost, expedice, cena bez DPH ----------
     Karta v kategoriích si tyhle tři věci nevymýšlí – mx-boost.js si pro každý
     produkt stáhne sekci `mx-boost-api` a vloží do karty hotové úryvky z motivu
     (.mx-inventory-status, .mx-shipping-date, .price__without-vat). Děláme totéž,
     takže našeptávač ukazuje přesně to co karta i detail.

     Proč ne vlastní výpočet: stav skladu motiv bere z ERP (produkt s 5 ks na
     skladě může být „Bude naskladněno"), ne z inventory_quantity, a cenu bez DPH
     nelze spolehlivě odvodit dělením – u B2B účtu je v okně katalogová cena,
     která v Boost indexu vůbec není. Jeden zdroj pravdy = motiv. */
  var mxCache = {};
  function mxSekce(handle) {
    if (!mxCache[handle]) {
      var root = (window.theme && window.theme.routes && window.theme.routes.root) || '';
      if (root === '/') root = '';
      mxCache[handle] = origFetch(root + '/products/' + encodeURIComponent(handle) + '?sections=mx-boost-api')
        .then(function (r) { return r.json(); })
        .then(function (d) { return new DOMParser().parseFromString(d['mx-boost-api'], 'text/html'); })
        .catch(function (e) { delete mxCache[handle]; throw e; });
    }
    return mxCache[handle];
  }

  function doplnZMotivu(li, handle, st) {
    if (li.getAttribute('data-tipa-mx')) return;
    li.setAttribute('data-tipa-mx', '1');
    mxSekce(handle).then(function (doc) {
      var stav = doc.querySelector('.mx-inventory-status');
      var txt = stav && (stav.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt && st) {
        st.textContent = txt;
        st.classList.remove('tipa-isw-stock--in', 'tipa-isw-stock--order', 'tipa-isw-stock--out');
        /* motiv rozlišuje jen dvě úrovně: normal = zelená, low = červená */
        st.classList.add(stav.getAttribute('data-inventory-level') === 'normal'
          ? 'tipa-isw-stock--in' : 'tipa-isw-stock--out');
      }
      var exp = doc.querySelector('.mx-shipping-date .shipping-date__date');
      var den = exp && (exp.textContent || '').replace(/\s+/g, ' ').trim();
      if (den && st && st.parentNode && !li.querySelector('.tipa-isw-ship')) {
        var sp = document.createElement('span');
        sp.className = 'tipa-isw-ship';
        sp.textContent = TXT.ship + ' ' + den;
        st.parentNode.insertBefore(sp, st.nextSibling);
      }
      var bez = doc.querySelector('.price__without-vat');
      var t = bez && (bez.textContent || '').replace(/\s+/g, ' ').trim();
      var cena = li.querySelector('.boost-sd__suggestion-queries-item-price');
      /* Firma platící DPH (5. 10. 2026): motiv má velkou cenu BEZ DPH a malou s DPH
         (.price__without-vat--gross). Boost kreslí velkou cenu z indexu s DPH, takže
         velkou i přeškrtnutou přepíšeme hodnotami z motivu, stejně jako mx-boost.js
         na kartách v kategoriích. Formát jako Boost: celé koruny bez „,00“. */
      if (cena && bez && bez.classList.contains('price__without-vat--gross')) {
        var bezNul = function (s) { return s.replace(/,00(?=\s*[^\d\s,.]*$)/, ''); };
        var hl = doc.querySelector('.price__current .js-value');
        var hlT = hl && bezNul((hl.textContent || '').replace(/\s+/g, ' ').trim());
        var hlEl = cena.querySelector('.boost-sd__format-currency--price-sale > span') ||
                   cena.querySelector('.boost-sd__suggestion-queries-item-amount--regular .boost-sd__format-currency > span');
        var nahradCastku = function (el, nova) {
          var stara = (el.textContent || '').trim();
          var al = el.getAttribute('aria-label');
          el.textContent = nova;
          if (al && stara) el.setAttribute('aria-label', al.replace(stara, nova));
        };
        if (hlT && hlEl) nahradCastku(hlEl, hlT);
        var pr = doc.querySelector('.price__was .js-value');
        var prT = pr && bezNul((pr.textContent || '').replace(/\s+/g, ' ').trim());
        var prBox = cena.querySelector('.boost-sd__format-currency--price-compare');
        var prEl = prBox && prBox.querySelector('span');
        if (prEl && hlT && hlEl) {   /* přeškrtnutou jen spolu s velkou, ať se nemíchá základ */
          if (prT) nahradCastku(prEl, prT);
          else prBox.hidden = true;
        }
      }
      if (t && cena && !cena.querySelector('.tipa-isw-novat')) {
        var n = document.createElement('span');
        n.className = 'tipa-isw-novat';
        n.textContent = t;
        cena.appendChild(n);
      }
    }).catch(function () { li.removeAttribute('data-tipa-mx'); });  /* zůstane odhad z Boost dat */
  }

  /* Výchozí stav okna (nic napsáno, „Oblíbené produkty“): Boost neposílá dotaz na API,
     takže k produktům nemáme varianty a tlačítko košíku by chybělo (zůstalo jen kolečko
     z CSS, které se barvilo najetím na celý řádek – 4. 10. 2026). Data se proto stáhnou
     z /products/<handle>.js, jen v tomto stavu (při psaní je přinese odpověď Boostu). */
  var dotazeno = {};
  function dotahniProdukt(handle) {
    if (!handle || dotazeno[handle] || norm(currentQuery()).length >= 2) return;
    dotazeno[handle] = 1;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    origFetch.call(window, root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        if (!map[handle]) map[handle] = { id: vs.length === 1 ? vs[0].id : null, available: !!p.available, qty: p.available ? 1 : 0 };
        schedule();
      })
      .catch(function () { /* zůstane kolečko z CSS */ });
  }

  function decorate(root) {
    var items = root.querySelectorAll(SEL_ITEM + ':not([data-tipa-atc])');
    for (var k = 0; k < items.length; k++) {
      var li = items[k];
      var a = li.querySelector(SEL_LINK);
      if (!a) continue;
      var handle = handleOf(a);
      var info = handle && map[handle];
      if (!info) { dotahniProdukt(handle); continue; }   /* odpověď ještě nedorazila – decorate() se zavolá znovu */
      li.setAttribute('data-tipa-atc', info.id && info.available ? 'cart' : 'link');

      var st = document.createElement('span');
      st.className = 'tipa-isw-stock';
      if (!info.available) { st.classList.add('tipa-isw-stock--out'); st.textContent = TXT.soldOut; }
      else if (info.qty > 0) { st.classList.add('tipa-isw-stock--in'); st.textContent = TXT.inStock; }
      else { st.classList.add('tipa-isw-stock--order'); st.textContent = TXT.onOrder; }
      var host = li.querySelector(SEL_SKU) || li.querySelector(SEL_RIGHT);
      if (host) host.appendChild(st);
      doplnZMotivu(li, handle, st);   /* přepíše odhad hodnotami z motivu + doplní expedici a cenu bez DPH */

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tipa-isw-atc';
      if (info.id && info.available) {
        btn.title = TXT.add;
        btn.setAttribute('aria-label', TXT.add + ': ' + (a.textContent || '').trim());
        btn.addEventListener('click', (function (id, b) {
          return function (e) { e.preventDefault(); e.stopPropagation(); addToCart(id, b); };
        })(info.id, btn));
      } else {
        btn.classList.add('tipa-isw-atc--link');
        btn.title = info.available ? TXT.pick : TXT.view;
        btn.setAttribute('aria-label', btn.title);
        btn.addEventListener('click', (function (href) {
          return function (e) { e.preventDefault(); e.stopPropagation(); window.location.href = href; };
        })(a.href));
      }
      li.appendChild(btn);                     /* mimo <a>, ať není tlačítko v odkazu */
    }
  }

  /* 2b. štítek slevy (Boost ho kreslí na fotku) přendat těsně nad cenu */
  function placeBadges(root) {
    var badges = root.querySelectorAll('.boost-sd__suggestion-queries-item--product .boost-sd__suggestion-queries-item-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.parentNode && b.parentNode.classList.contains('boost-sd__suggestion-queries-item-price')) continue;
      var price = b.closest(SEL_ITEM) && b.closest(SEL_ITEM).querySelector('.boost-sd__suggestion-queries-item-price');
      if (price) price.insertBefore(b, price.firstChild);
    }
  }

  /* 5. hledané výrazy */
  var dotazy = null;           /* [{t: text, n: normalizovaný text, s: skóre}] */
  var dotazyLoading = false;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }

  function loadDotazy() {
    loadZnacky();
    loadKategorie();
    if (dotazy || dotazyLoading) return;
    var inline = window.TIPA_ISW_DOTAZY;
    if (inline) { setDotazy(inline); return; }
    if (!DOTAZY_URL) return;
    dotazyLoading = true;
    origFetch.call(window, DOTAZY_URL).then(function (r) { return r.json(); })
      .then(function (arr) { setDotazy(arr); schedule(); })
      .catch(function () { dotazyLoading = false; });
  }
  /* 8. mapa značek: normalizovaný dotaz -> handle značkové kolekce */
  var znacky = null, znackyLoading = false;
  function loadZnacky() {
    if (znacky || znackyLoading) return;
    if (window.TIPA_ISW_ZNACKY) { znacky = window.TIPA_ISW_ZNACKY; return; }
    if (!ZNACKY_URL) return;
    znackyLoading = true;
    origFetch.call(window, ZNACKY_URL).then(function (r) { return r.json(); })
      .then(function (m) { znacky = m || {}; schedule(); })
      .catch(function () { znackyLoading = false; });
  }
  function brandFor(q) {
    var qn = norm(q);
    if (!znacky || !qn) return null;
    return znacky[qn] || znacky[qn.replace(/-/g, ' ')] || znacky[qn.replace(/[-\s]/g, '')] || null;
  }
  function brandTitle(handle) {
    for (var i = 0; i < prodCats.length; i++) if (prodCats[i].handle === handle) return prodCats[i].title;
    return null;
  }
  /* Proklik na návrh dotazu, který je značkou (fnirsi, rebel…), vede rovnou na kolekci
     značky místo /search. Jen značky z mapy (20+ produktů) – „tuya" má kolekci prázdnou
     a hledání najde 389 produktů, přesměrování by tam škodilo (ověřeno 22. 9. 2026). */
  function znackyVOdkazech(root) {
    if (!znacky) return;
    var odkazy = root.querySelectorAll('.boost-sd__suggestion-queries-link');
    for (var i = 0; i < odkazy.length; i++) {
      var a = odkazy[i];
      if (a.getAttribute('data-tipa-brand')) continue;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/search') !== 0 && href.indexOf('/search') === -1) continue;   /* jen návrhy dotazů */
      var li = a.parentNode;
      var q = (li && li.getAttribute && li.getAttribute('data-title')) || queryFromUrl(href) || a.textContent;
      var h = brandFor(q);
      if (!h) continue;
      a.setAttribute('data-tipa-brand', h);
      a.setAttribute('href', '/collections/' + h);
    }
  }

  function redirectIfBrand(q) {
    var h = brandFor(q);
    if (!h) return false;
    window.location.href = '/collections/' + h;
    return true;
  }

  /* 10. obrázek u kategorie: K1 piktogram, ostatní miniatura fotky */
  var katData = null, katLoading = false;
  function loadKat() {
    if (katData || katLoading) return;
    try { katData = JSON.parse(sessionStorage.getItem(KAT_KEY) || 'null'); } catch (e) { katData = null; }
    if (katData) return;
    katLoading = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    origFetch.call(window, root + '?sections=' + KAT_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var m = /<script[^>]*data-tipa-isw-kat[^>]*>([\s\S]*?)<\/script>/.exec(j[KAT_SECTION] || '');
        var d = m ? JSON.parse(m[1]) : null;
        if (!d || !d.m) throw new Error('bez dat');
        katData = d;
        try { sessionStorage.setItem(KAT_KEY, JSON.stringify(d)); } catch (e) { /* plné úložiště – příště znovu */ }
        schedule();
      })
      .catch(function () { katLoading = false; });
  }
  function obrazekKategorie(handle) {
    if (!katData) return null;
    if (Object.prototype.hasOwnProperty.call(katData.k, handle) && handle) {
      var svg = katData.i[katData.k[handle]] || '';
      return svg.replace('class="tipa-ico"', 'class="tipa-isw-ico"');
    }
    if (!handle || !Object.prototype.hasOwnProperty.call(katData.m, handle)) return null;   /* mimo strom */
    var src = katData.m[handle];
    if (src && !/^(https?:)?\/\//.test(src)) src = katData.c + src;
    return '<span class="tipa-isw-thumb">' + (src
      ? '<img src="' + esc(src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=64') + '" width="32" height="32" loading="lazy" alt="">'
      : '') + '</span>';
  }
  /* všechny odkazy na kolekce ve skupinách kategorií (Boostovy, naše, oblíbené); značky ne */
  function ikonyKategorii(col) {
    if (!katData) return;
    /* skupinu poznáme podle nadpisu (bez :has – ve starším prohlížeči by výjimka zastavila celé dokreslení) */
    var nadpisy = col.querySelectorAll('.boost-sd__suggestion-queries-header--collections');
    var odkazy = [];
    for (var n = 0; n < nadpisy.length; n++) {
      var sk = nadpisy[n].closest('.boost-sd__suggestion-queries-group');
      if (sk) odkazy.push.apply(odkazy, sk.querySelectorAll('.boost-sd__suggestion-queries-link:not([data-tipa-ico])'));
    }
    for (var i = 0; i < odkazy.length; i++) {
      var a = odkazy[i];
      var handle = ((a.getAttribute('href') || '').split('/collections/')[1] || '').split(/[?#]/)[0];
      if (!handle || /^brand-/.test(handle)) continue;
      var html = obrazekKategorie(handle);
      if (!html) continue;                                  /* mimo strom: obecná ikona z CSS */
      a.setAttribute('data-tipa-ico', '');
      a.insertAdjacentHTML('afterbegin', html);
    }
  }

  /* 11. banner ve třetím sloupci desktopového okna */
  var banner = null, bannerCol = null;
  function najdiBanner() {
    if (!banner) banner = document.querySelector('[data-tipa-isw-banner]');
    return banner;
  }
  function nahrajBanner() {
    var b = najdiBanner(), img = b && b.querySelector('img');
    if (img && img.loading !== 'eager') img.loading = 'eager';
  }
  function umistiBanner() {
    if (!najdiBanner()) return;
    var auto = document.querySelector('.boost-sd__instant-search-results--two-column .boost-sd__instant-search-autocomplete');
    if (!auto || (bannerCol && bannerCol.parentNode === auto)) return;
    if (!bannerCol) {
      bannerCol = document.createElement('div');
      bannerCol.className = 'tipa-isw-bancol';
    }
    nahrajBanner();
    banner.hidden = false;
    bannerCol.appendChild(banner);
    auto.appendChild(bannerCol);
  }

  /* 9. výchozí stav: losované oblíbené kategorie */
  var kategorie = null, kategorieLoading = false;
  /* data nesou datum generování; po STARI_DNI se ozve do konzole, ať se na obnovu nezapomene */
  var STARI_DNI = 120;
  function normKategorie(x) {
    if (!x) return [];
    if (Array.isArray(x)) return x;                 /* starší formát bez data */
    if (x.d) {
      var dni = Math.round((Date.now() - new Date(x.d).getTime()) / 86400000);
      if (dni > STARI_DNI && window.console) {
        console.warn('[tipa-isw] Oblíbené kategorie jsou z ' + x.d + ' (' + dni + ' dní). '
          + 'Obnova: scripts/build_boost_search_kategorie.py – viz shopify/NASAZENI-boost-search.md');
      }
    }
    return x.k || [];
  }

  function loadKategorie() {
    if (kategorie || kategorieLoading) return;
    if (window.TIPA_ISW_KATEGORIE) { kategorie = normKategorie(window.TIPA_ISW_KATEGORIE); return; }
    if (!KATEGORIE_URL) return;
    kategorieLoading = true;
    origFetch.call(window, KATEGORIE_URL).then(function (r) { return r.json(); })
      .then(function (arr) { kategorie = normKategorie(arr); schedule(); })
      .catch(function () { kategorieLoading = false; });
  }
  /* vážený výběr bez opakování; výsledek drží celou návštěvu */
  function vybraneKategorie() {
    if (!kategorie || !kategorie.length) return [];
    try {
      var ulozene = sessionStorage.getItem(SESSION_KEY);
      if (ulozene) {
        var p = JSON.parse(ulozene);
        if (p && p.length) return p;
      }
    } catch (e) { /* private mode – losuje se pokaždé */ }
    var zbytek = kategorie.slice(), vybrano = [];
    while (vybrano.length < MAX_DEFAULT_CATS && zbytek.length) {
      var soucet = 0, i;
      for (i = 0; i < zbytek.length; i++) soucet += zbytek[i][2] || 1;
      var los = Math.random() * soucet, beh = 0, idx = zbytek.length - 1;
      for (i = 0; i < zbytek.length; i++) { beh += zbytek[i][2] || 1; if (los <= beh) { idx = i; break; } }
      vybrano.push(zbytek.splice(idx, 1)[0]);
    }
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(vybrano)); } catch (e) { /* nic */ }
    return vybrano;
  }

  /* 9b. živý výpočet kategorií z Boostových populárních hledání */
  function boostPopularniDotazy() {
    try {
      var mods = window.boostWidgetIntegration.TAEApp.modules;
      for (var i = 0; i < mods.length; i++) {
        var b = mods[i] && mods[i].block;
        var st = b && b.widgetInfo && b.widgetInfo.searchSettings;
        var d = st && st.suggestionNoResult && st.suggestionNoResult.search_terms;
        if (d && d.data && d.data.length) return d.data.slice(0, ZIVE_DOTAZU);
      }
    } catch (e) { /* nic */ }
    return [];
  }

  function jeKategorie(handle) {
    return handle && !/^brand-/.test(handle) && !BLOKOVANE[handle] && !K1[handle];
  }

  /* Adresa pro vlastní dotaz na API. Ve výchozím stavu (nic napsáno) Boost žádný
     dotaz neposílá, takže se nelze spolehnout na šablonu z předchozího requestu
     (chyba nalezena 22. 9. 2026) – parametry vezmeme z konfigurace Boostu a Shopify. */
  function suggestUrl(q) {
    if (lastSuggestUrl) {
      return lastSuggestUrl
        .replace(/([?&]q=)[^&]*/, '$1' + encodeURIComponent(q))
        .replace(/([?&]t=)\d+/, '$1' + Date.now())
        .replace(/([?&]product_limit=)\d+/, '$16')
        .replace(/([?&]collection_limit=)\d+/, '$12')
        .replace(/([?&](?:suggestion|page)_limit=)\d+/g, '$10');
    }
    var app = null;
    try {
      var mods = window.boostWidgetIntegration.TAEApp.modules;
      for (var i = 0; i < mods.length; i++) if (mods[i] && mods[i].block && mods[i].block.app && mods[i].block.app.searchUrl) { app = mods[i].block.app; break; }
    } catch (e) { /* nic */ }
    var base = (app && app.searchUrl) || 'https://services.mybcapps.com/bc-sf-filter/search';
    var sh = window.Shopify || {};
    var p = ['shop=' + encodeURIComponent(sh.shop || ''), 'event_type=suggest',
             'q=' + encodeURIComponent(q), 'product_limit=6', 'collection_limit=2',
             'suggestion_limit=0', 'page_limit=0', 'product_available=true',
             'locale=' + encodeURIComponent(sh.locale || 'cs'),
             'currency=' + encodeURIComponent((sh.currency && sh.currency.active) || 'CZK'),
             'country=' + encodeURIComponent(sh.country || 'CZ'), 't=' + Date.now()];
    return base + '/suggest?' + p.join('&');
  }

  var ziveSpusteno = false;
  function spocitejKategorieZive() {
    if (ziveSpusteno) return;
    var dotazy = boostPopularniDotazy();
    if (!dotazy.length) return;
    ziveSpusteno = true;
    var perDotaz = {}, tituly = {}, hotovo = 0;   /* kategorie zvlášť za každý dotaz, viz round-robin níž */
    dotazy.forEach(function (q) {
      var acc = perDotaz[q] = {};
      origFetch.call(window, suggestUrl(q)).then(function (r) { return r.json(); }).then(function (j) {
        (j.collections || []).forEach(function (c) {        /* shoda názvu/popisu kolekce váží víc */
          if (!jeKategorie(c.handle)) return;
          acc[c.handle] = (acc[c.handle] || 0) + 3; tituly[c.handle] = c.title || c.handle;
        });
        (j.products || []).forEach(function (p) {
          (p.collections || []).forEach(function (c) {
            if (!jeKategorie(c.handle)) return;
            acc[c.handle] = (acc[c.handle] || 0) + 1; tituly[c.handle] = c.title || c.handle;
          });
        });
      }).catch(function () { /* jeden dotaz může selhat */ })
        .then(function () {
          if (++hotovo < dotazy.length) return;
          /* z každého dotazu ber postupně jeho nejlepší kategorii – jinak by pětici
             ovládlo jedno téma (dva bateriové dotazy = tři bateriové kategorie) */
          var poradi = {}, zive = [], videno = {}, kolo = 0;
          dotazy.forEach(function (d) {
            poradi[d] = Object.keys(perDotaz[d] || {}).sort(function (a, b) { return perDotaz[d][b] - perDotaz[d][a]; });
          });
          while (kolo < 5 && zive.length < MAX_DEFAULT_CATS) {
            for (var di = 0; di < dotazy.length && zive.length < MAX_DEFAULT_CATS; di++) {
              var h = (poradi[dotazy[di]] || [])[kolo];
              if (h && !videno[h]) { videno[h] = 1; zive.push([tituly[h], h]); }
            }
            kolo++;
          }
          if (!zive.length) return;
          /* doplnit ze statického žebříčku, kdyby živých bylo málo */
          var vybrano = zive.slice(0, MAX_DEFAULT_CATS), mam = {};
          vybrano.forEach(function (k) { mam[k[1]] = 1; });
          (kategorie || []).forEach(function (k) {
            if (vybrano.length < MAX_DEFAULT_CATS && !mam[k[1]]) { vybrano.push([k[0], k[1]]); mam[k[1]] = 1; }
          });
          try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(vybrano)); } catch (e) { /* nic */ }
          var col = document.querySelector('.boost-sd__instant-search-column--others');
          if (col) col.removeAttribute('data-tipa-groups');
          schedule();
        });
    });
  }

  function setDotazy(arr) {
    dotazy = [];
    for (var i = 0; i < arr.length; i++) dotazy.push({ t: arr[i][0], n: norm(arr[i][0]), s: arr[i][1] });
  }

  function suggestQueries(q) {
    var qn = norm(q);
    if (!dotazy || qn.length < 2) return [];
    var starts = [], words = [];
    for (var i = 0; i < dotazy.length && (starts.length < MAX_QUERIES || words.length < MAX_QUERIES); i++) {
      var d = dotazy[i];
      if (d.n === qn) continue;
      if (d.n.indexOf(qn) === 0) { if (starts.length < MAX_QUERIES) starts.push({ t: d.t, at: 0, len: q.trim().length }); }
      else {
        var p = d.n.indexOf(' ' + qn);
        if (p !== -1 && words.length < MAX_QUERIES) words.push({ t: d.t, at: p + 1, len: q.trim().length });
      }
    }
    return starts.concat(words).slice(0, MAX_QUERIES);
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function makeGroup(kind, label) {
    var g = document.createElement('div');
    g.className = 'boost-sd__suggestion-queries-group tipa-isw-group tipa-isw-group--' + kind;
    g.innerHTML = '<h3 class="boost-sd__header-item boost-sd__suggestion-queries-header boost-sd__suggestion-queries-header--tipa-' + kind + '">' + esc(label) + '</h3>' +
                  '<ul class="boost-sd__suggestion-queries-list"></ul>';
    return g;
  }
  function makeItem(href, html, title) {
    var li = document.createElement('li');
    li.className = 'boost-sd__suggestion-queries-item';
    li.setAttribute('data-title', title);
    li.innerHTML = '<a class="boost-sd__suggestion-queries-link" href="' + esc(href) + '"><span>' + html + '</span></a>';
    return li;
  }

  function currentQuery() {
    var c = window.boostISWModule && window.boostISWModule.instantSearchController;
    var id = c && c.state && c.state.activeInputId;
    var input = (id && document.getElementById(id)) || document.querySelector('.boost-sd__search-widget-init-input:focus');
    return input ? input.value : '';
  }

  /* 5–7. skupiny v levém sloupci (desktopová šablona) */
  function groupItems(g) { return g ? g.querySelectorAll('.boost-sd__suggestion-queries-item') : []; }
  function findGroup(col, cls) {
    var groups = col.querySelectorAll('.boost-sd__suggestion-queries-group');
    for (var i = 0; i < groups.length; i++) {
      var h = groups[i].querySelector('.boost-sd__suggestion-queries-header');
      if (h && h.classList.contains(cls)) return groups[i];
    }
    return null;
  }

  function augmentGroups() {
    /* Obě šablony jsou v DOM současně (mobilní i desktopová, jedna skrytá), takže se
       obsluhují obě. Mobilní VÝCHOZÍ stav navíc sloupec --others nemá – bloky visí
       rovnou v obalu; bez toho se na mobilu kategorie nezobrazily (22. 9. 2026). */
    var cols = [];
    var i, n;
    var sloupce = document.querySelectorAll('.boost-sd__instant-search-results .boost-sd__instant-search-column--others');
    for (i = 0; i < sloupce.length; i++) cols.push(sloupce[i]);
    var obaly = document.querySelectorAll('.boost-sd__instant-search-results--mobile .boost-sd__instant-search-autocomplete');
    for (i = 0; i < obaly.length; i++) {
      if (!obaly[i].querySelector('.boost-sd__instant-search-column--others')) cols.push(obaly[i]);
    }
    for (n = 0; n < cols.length; n++) augmentColumn(cols[n]);
  }

  function augmentColumn(col) {
    var mobile = !!col.closest('.boost-sd__instant-search-results--mobile');
    loadDotazy();                                  /* pojistka, kdyby focusin nepřišel */
    loadKat();                                     /* totéž pro obrázky kategorií (ze sessionStorage hned) */
    var q = currentQuery();
    var qn = norm(q);
    var stamp = qn + '|' + (dotazy ? 1 : 0) + (katData ? 1 : 0) + '|' + vendors.join(',') + '|' + prodCats.length + '|' + articlesFor + ':' + articles.length;
    if (col.getAttribute('data-tipa-groups') === stamp) return;
    col.setAttribute('data-tipa-groups', stamp);
    col.querySelectorAll('.tipa-isw-group').forEach(function (g) { g.parentNode.removeChild(g); });
    /* položky, které jsme dřív přesunuli, vrátit do skupin Boostu není třeba – Boost sloupec staví znovu */

    var boostSugg = findGroup(col, 'boost-sd__suggestion-queries-header--suggestions');
    var catGroup = findGroup(col, 'boost-sd__suggestion-queries-header--collections');
    var pageGroup = findGroup(col, 'boost-sd__suggestion-queries-header--pages');
    var watermark = col.querySelector('.boost-sd__watermark-powered-by-boost');
    var productList = col.querySelector('.boost-sd__instant-search-product-list');   /* jen mobil: produkty jsou v témž sloupci */
    var maxQ = mobile ? 3 : MAX_QUERIES;
    var sameQuery = norm(lastQuery) === qn;      /* data z API patří k aktuálnímu dotazu */

    /* Hledané výrazy: Boostovy návrhy (historie hledání obchodu – u kódů typu „ut18" dobré)
       napřed, pak náš slovník; bez duplicit, napsaná část tučně */
    /* výchozí stav (nic napsáno): jen losované oblíbené kategorie, zbytek nechá Boost */
    if (qn.length < 2) {
      var favs = vybraneKategorie();
      spocitejKategorieZive();
      znackyVOdkazech(col);
      if (favs.length) {
        var gf = makeGroup('cats', TXT.favCats);
        gf.querySelector('h3').classList.add('boost-sd__suggestion-queries-header--collections');
        var ulf = gf.querySelector('ul');
        favs.forEach(function (k) { ulf.appendChild(makeItem('/collections/' + k[1], esc(k[0]), k[0])); });
        var prvni = col.querySelector('.boost-sd__suggestion-queries-group:not(.tipa-isw-group)');
        col.insertBefore(gf, prvni || col.firstChild);
      }
      ikonyKategorii(col);
      return;
    }

    var gq = null, seenQ = {}, nQ = 0;
    var boostLis = groupItems(boostSugg);
    var sugg = suggestQueries(q);
    if (boostLis.length || sugg.length) {
      gq = makeGroup('queries', TXT.queries);
      var ul = gq.querySelector('ul');
      for (var b = 0; b < boostLis.length && nQ < maxQ; b++) {
        var li0 = boostLis[b], t0 = (li0.getAttribute('data-title') || li0.textContent).trim();
        if (seenQ[norm(t0)]) continue;
        seenQ[norm(t0)] = 1; nQ++;
        var span = li0.querySelector('a span') || li0.querySelector('a');
        var pos = norm(t0).indexOf(qn);
        if (span && pos !== -1 && qn.length) span.innerHTML = esc(t0.slice(0, pos)) + '<b>' + esc(t0.slice(pos, pos + q.trim().length)) + '</b>' + esc(t0.slice(pos + q.trim().length));
        ul.appendChild(li0);
      }
      for (var si = 0; si < sugg.length && nQ < maxQ; si++) {
        var sg = sugg[si], t = sg.t;
        if (seenQ[norm(t)]) continue;
        seenQ[norm(t)] = 1; nQ++;
        ul.appendChild(makeItem('/search?q=' + encodeURIComponent(t), esc(t.slice(0, sg.at)) + '<b>' + esc(t.slice(sg.at, sg.at + sg.len)) + '</b>' + esc(t.slice(sg.at + sg.len)), t));
      }
      if (boostSugg) boostSugg.parentNode.removeChild(boostSugg);
    }

    /* Kategorie: Boostovy (shoda titulku) + kolekce nalezených produktů */
    var seenCat = {}, brandLis = [], seenBrand = {};
    groupItems(catGroup).forEach(function (li) {
      var a = li.querySelector('a'); var href = a ? a.getAttribute('href') || '' : '';
      var handle = (href.split('/collections/')[1] || '').split(/[?#]/)[0];
      if (/^brand-/.test(handle)) { brandLis.push(li); seenBrand[handle] = 1; li.parentNode.removeChild(li); }
      else seenCat[handle] = 1;
    });
    var catUl = catGroup ? catGroup.querySelector('ul') : null;
    if (sameQuery) {
      var nCats = Object.keys(seenCat).length;
      for (var i = 0; i < prodCats.length && nCats < MAX_CATS; i++) {
        var c = prodCats[i];
        if (c.brand || seenCat[c.handle]) continue;
        if (!catGroup) { catGroup = makeGroup('cats', TXT.cats); catGroup.querySelector('h3').classList.add('boost-sd__suggestion-queries-header--collections'); catUl = catGroup.querySelector('ul'); }
        catUl.appendChild(makeItem('/collections/' + c.handle, esc(c.title), c.title));
        seenCat[c.handle] = 1; nCats++;
      }
    }
    if (catGroup && !groupItems(catGroup).length) { catGroup.parentNode.removeChild(catGroup); catGroup = null; }

    /* Značky: brand-* kolekce nalezených produktů + brand-* položky od Boostu + výrobci se shodou prefixu */
    var gb = null, brandItems = [];
    if (sameQuery) {
      prodCats.forEach(function (c) { if (c.brand && !seenBrand[c.handle] && brandItems.length + brandLis.length < MAX_BRANDS) { seenBrand[c.handle] = 1; brandItems.push(makeItem('/collections/' + c.handle, esc(c.title), c.title)); } });
    }
    var brandNames = {};
    brandLis.concat(brandItems).forEach(function (li) { brandNames[norm(li.getAttribute('data-title') || li.textContent)] = 1; });
    if (sameQuery && qn.length >= 2) {
      vendors.forEach(function (v) {
        var vn = norm(v);
        if (brandNames[vn] || brandLis.length + brandItems.length >= MAX_BRANDS) return;
        if (vn.indexOf(qn) === 0 || vn.indexOf(' ' + qn) !== -1) { brandNames[vn] = 1; brandItems.push(makeItem('/collections/vendors?q=' + encodeURIComponent(v), esc(v), v)); }
      });
    }
    if (brandLis.length || brandItems.length) {
      gb = makeGroup('brands', TXT.brands);
      var ulb = gb.querySelector('ul');
      brandLis.forEach(function (li) { ulb.appendChild(li); });
      brandItems.forEach(function (li) { ulb.appendChild(li); });
    }

    /* Články: Boostovy (titulek) + Shopify (titulek i text) */
    if (sameQuery && articlesFor === lastQuery && articles.length) {
      var seenUrl = {};
      groupItems(pageGroup).forEach(function (li) { var a = li.querySelector('a'); if (a) seenUrl[(a.getAttribute('href') || '').split(/[?#]/)[0]] = 1; });
      var pageUl = pageGroup ? pageGroup.querySelector('ul') : null;
      var nPages = Object.keys(seenUrl).length;
      for (var k = 0; k < articles.length && nPages < MAX_ARTICLES; k++) {
        var art = articles[k]; var u = (art.url || '').split(/[?#]/)[0];
        if (!u || seenUrl[u]) continue;
        if (!pageGroup) { pageGroup = makeGroup('articles', TXT.articles); pageGroup.querySelector('h3').classList.add('boost-sd__suggestion-queries-header--pages'); pageUl = pageGroup.querySelector('ul'); }
        pageUl.appendChild(makeItem(u, esc(art.title), art.title));
        seenUrl[u] = 1; nPages++;
      }
    }

    /* pořadí: desktop dotazy, kategorie, značky, články; mobil má v témž sloupci
       i produkty – ty hned za dotazy, ať jsou na první obrazovce */
    var order = mobile ? [gq, productList, catGroup, gb, pageGroup, watermark] : [gq, catGroup, gb, pageGroup, watermark];
    order.forEach(function (g) { if (g) col.appendChild(g); });
    znackyVOdkazech(col);
    ikonyKategorii(col);

    /* dotaz = značka: tlačítko dole vede na značkovou kolekci */
    var results = col.closest('.boost-sd__instant-search-results');
    var viewAll = results && results.querySelector('.boost-sd__view-all-link');
    var bh = brandFor(q);
    if (viewAll) {
      if (bh && !viewAll.hasAttribute('data-tipa-brand')) {
        var txt = viewAll.querySelector('.boost-sd__view-all-text') || viewAll;
        viewAll.setAttribute('data-tipa-brand', bh);
        viewAll.setAttribute('data-tipa-orig-href', viewAll.getAttribute('href') || '');
        viewAll.setAttribute('href', '/collections/' + bh);
        var bt = brandTitle(bh) || q.trim().toUpperCase();
        txt.textContent = TXT.viewBrand.replace('{znacka}', bt);
      } else if (!bh && viewAll.hasAttribute('data-tipa-brand')) {
        viewAll.setAttribute('href', viewAll.getAttribute('data-tipa-orig-href'));
        viewAll.removeAttribute('data-tipa-brand');   /* text obnoví Boost při dalším překreslení */
      }
    }
    col.classList.toggle('tipa-isw-has-queries', !!gq);
  }

  /* 4. pozice okna: CSS ho má position:fixed, top bere z --tipa-isw-top.
        Měříme spodní hranu aktivního pole, protože „top:auto" (pozice v toku)
        u dvouřádkového menu vychází až pod navigaci. */
  function positionWidget() {
    var c = window.boostISWModule && window.boostISWModule.instantSearchController;
    var id = c && c.state && c.state.activeInputId;
    var input = (id && document.getElementById(id)) || document.querySelector('.boost-sd__search-widget-init-input:focus');
    if (!input) return;
    var r = input.getBoundingClientRect();
    if (!r.height) return;
    document.documentElement.style.setProperty('--tipa-isw-top', Math.round(r.bottom + 6) + 'px');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; positionWidget(); augmentGroups(); umistiBanner(); placeBadges(document); decorate(document); });
  }

  function start() {
    /* Boost okno překresluje výměnou celého stromu – mutace pak sedí na jeho OBALU,
       ne uvnitř. Proto se hlídá i obal a přidané uzly (chyba nalezena 22. 9. 2026:
       štítek slevy zůstal na fotce, když poslední překreslení přišlo po našem průchodu). */
    var WATCH = '.boost-sd__search-widget-init-wrapper, .boost-sd__instant-search-results, .boost-sd__instant-search-container, #bc-instant-search';
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType !== 1) continue;
        if (t.closest && t.closest(WATCH)) { schedule(); return; }
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && ((n.matches && n.matches(WATCH)) || (n.querySelector && n.querySelector('.boost-sd__instant-search-results')))) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    /* Enter v poli hledání nebo odeslání formuláře s dotazem = značka -> kolekce značky.
       Zachyceno v capture fázi, aby to předběhlo Boost (ten by šel na /search?q=). */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('boost-sd__search-widget-init-input')) return;
      if (redirectIfBrand(t.value)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.querySelector) return;
      var inp = f.querySelector('.boost-sd__search-widget-init-input, input[name="q"]');
      if (inp && redirectIfBrand(inp.value)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    /* 12. Karty Boostu ve výpisu kolekcí: „Přidat do košíku“ vloží zboží přes drawer
          a zákazník zůstane v kolekci (dřív Boost přesměroval do /cart, 4. 10. 2026).
          Tlačítko nese variantu v data-metadata (action.addToCart.productId = ID varianty).
          Zachyceno v capture fázi na window, tedy dřív než posluchače Boostu. Tlačítka bez
          addToCart (výběr varianty, předplatné) nechává Boostu. */
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.boost-sd__product-item .boost-sd__button--select-option');
      if (!b) return;
      var meta;
      try { meta = JSON.parse(b.getAttribute('data-metadata') || '{}'); } catch (x) { return; }
      var add = meta && meta.action && meta.action.addToCart;
      if (!add || !add.productId || add.selling_plan) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(add.productId, b);
    }, true);
    window.addEventListener('resize', schedule);
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('boost-sd__search-widget-init-input')) { loadDotazy(); loadKat(); nahrajBanner(); schedule(); }
    });
    /* najetí myší na pole: stáhnout ikony a obrázek banneru dřív, než se okno otevře */
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('boost-sd__search-widget-init-input')) { loadKat(); nahrajBanner(); }
    }, { passive: true });
    decorate(document);
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* TIPA: pole hledání – při novém vstupu do pole (kliknutí, klepnutí, Tab) se dosavadní
   text označí, takže první napsaný znak ho nahradí. Druhé kliknutí do už aktivního pole
   umístí kurzor normálně a v původním textu jde pokračovat.
   Označení se opakuje krátce po fokusu: Boost se na stránce inicializuje až při první
   interakci a přitom kurzor přesune na začátek. Jakmile uživatel píše, už se nic nemění. */
(function () {
  if (window.tipaSearchSelectInit) return;
  window.tipaSearchSelectInit = true;
  var SEL = 'input[type="search"], input[name="q"], .boost-sd__search-widget-init-input';
  var armed = null;
  var typed = false;

  function selectAll(input) {
    if (typed || document.activeElement !== input || !input.value) return;
    try { input.setSelectionRange(0, input.value.length); } catch (e) {}
  }

  document.addEventListener('focusin', function (evt) {
    var input = evt.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(SEL) || !input.value) return;
    armed = input;
    typed = false;
    selectAll(input);
    requestAnimationFrame(function () { selectAll(input); });
    [80, 200, 400].forEach(function (ms) { setTimeout(function () { selectAll(input); }, ms); });
  }, true);

  // psaní nebo vložení textu ukončí opakované označování
  ['keydown', 'input', 'paste'].forEach(function (name) {
    document.addEventListener(name, function (evt) {
      if (evt.target === armed) typed = true;
    }, true);
  });

  // mouseup hned po prvním kliknutí by výběr zrušil a dal kurzor na místo kliknutí
  document.addEventListener('mouseup', function (evt) {
    if (armed && evt.target === armed) evt.preventDefault();
  }, true);
  // druhé kliknutí do už aktivního pole = normální kurzor
  document.addEventListener('mousedown', function (evt) {
    if (armed && evt.target === armed && document.activeElement === armed) { typed = true; armed = null; }
  }, true);
  document.addEventListener('focusout', function (evt) {
    if (evt.target === armed) armed = null;
  }, true);
})();

